import api from '../Utils/api'

export const createFeedback = async (data) => {
  const apiResponse = await api('POST', 'feedbacks', data)
  return apiResponse
}

export const getFeedback = async (referenceId, feedbackType) => {
  const apiResponse = await api(
    'GET',
    `feedbacks?referenceId=${referenceId}&feedbackType=${feedbackType}`,
    null
  )
  return apiResponse
}

export const updateFeedback = async (id, data) => {
  const apiResponse = await api('PUT', `feedbacks/${id}`, data)
  return apiResponse
}
